import { Controller } from '@hotwired/stimulus'

// Keeps the "Mandatory" tab in sync with the teams picked in the General tab:
// only rows for currently selected teams are shown, and hidden rows are
// disabled so they never submit.
export default class extends Controller {
  static targets = ['teamCheckbox', 'row', 'empty']

  connect() {
    this.refresh()
  }

  refresh() {
    const selected = this.teamCheckboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value)

    let anyVisible = false

    this.rowTargets.forEach((row) => {
      const visible = selected.includes(row.dataset.teamId)
      row.classList.toggle('hidden', !visible)
      row.querySelectorAll('input').forEach((input) => { input.disabled = !visible })
      if (visible) anyVisible = true
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle('hidden', anyVisible)
    }
  }
}
